<td
  class="pa-table-group-row"
  [attr.colspan]="colspan"
  (click)="handleToggle()"
>
  <div class="pa-table-group-row__content">
    <i
      class="pi pa-table-group-row__icon"
      [ngClass]="expanded ? 'pi-chevron-down' : 'pi-chevron-right'"
    ></i>
    <div class="pa-table-group-row__text">
      <div class="pa-table-group-row__title">
        {{ title }}
      </div>
      <div
        *ngIf="subtitle"
        class="pa-table-group-row__subtitle"
      >
        {{ subtitle }}
      </div>
    </div>
  </div>
</td>

